// extracted by mini-css-extract-plugin
export default {"monitoringContainer":"NewMonitoring_monitoringContainer__p4I6M"};